module.exports = __webpack_public_path__ + "img/light2.ccda5bba.png";